<main>
<div class="title-filter-block">
  <ng-container *ngTemplateOutlet="seoCrumbs"></ng-container>
  <div class="title-pharmacies-wrapper">
    <ng-container *ngIf="_search_pharmcy_params_name">
      <h1 class="main-heading">
        {{_search_pharmcy_params_name}} в {{ cityForH1 }}
      </h1>
    </ng-container>
    <ng-container *ngIf="isListSearch">
      <h1 class="main-heading">
        {{'preparatList' | transloco}} {{_search_pharmcy_params_count}} шт.
      </h1>
    </ng-container>
  </div>
</div>

<bz-return-btn-arrow [easyBack]="true" [isPharmcyListMobile]="true" (click)="toggleMobilePageState()"
  (pushBtnReturn)="backState()" class="bz-return-btn">
  <ng-container *ngIf="!isListSearch else list">
    {{_search_pharmcy_params_name}}
  </ng-container>
  <ng-template #list>
    {{'preparatList' | transloco}} {{_search_pharmcy_params_count}} шт.
  </ng-template>
</bz-return-btn-arrow>

<ng-container *ngIf="isActiveMapPage | async">
  <div class="switch-block" [ngStyle]="{'flex-direction': 'row-reverse', 'align-items': 'center'}">
    <div [ngClass]="{'city-change-block': isActiveMapPage | async}" [ngStyle]="{'border':
            (selectedAddress | async) ? '1px solid #449bd1' :
            '1px solid #e4e4e4', 'height': '34px', 'font-weight':
            '500', 'padding':
            '0 10px 0 14px'}" (click)="toChangeRegion()">
      {{'address' | transloco}}
    </div>

    <div class="btn-ddm filter-btn mobile-filters-ddm" (click)="openMobileFiltersModal()">
      <span class="icon-btn-ddm" [ngClass]="{
        'filter-switcher-enable': (countOfActiveMobileFilters | async | pharmaciesFiltersCount:currentFilterForBlock:filterList:isListSearch) > 0
      }" [ngStyle]="iconFtObj"></span>
      <span
        *ngIf="(countOfActiveMobileFilters | async | pharmaciesFiltersCount:currentFilterForBlock:filterList:isListSearch) === 0">{{'filter'
        | transloco}}</span>
      <span
        *ngIf="(countOfActiveMobileFilters | async | pharmaciesFiltersCount:currentFilterForBlock:filterList:isListSearch) > 0">{{'activeMobileFilters'
        | transloco}}
        ({{ countOfActiveMobileFilters | async | pharmaciesFiltersCount:currentFilterForBlock:filterList:isListSearch
        }})</span>
    </div>
  </div>
</ng-container>

<div class="content">
  <ng-container *ngTemplateOutlet="!(isActiveMapPage | async) ? listTemplate : mapTemplate"></ng-container>
  <ng-container *ngTemplateOutlet="scr.isDesktop() ? mapTemplate : null"></ng-container>
</div>
</main>

<ng-template #listTemplate>
  <div [ngStyle]="{'min-height': (isLoadingListPharmacies | async) ? '60vh' : 'unset'}"
    class="pharmacies-wrapper scrollbar" style="position: relative">

    <div class="address-desktop">
      <p class="address">{{ selectedUserCityName }},
        <span class="no-address" *ngIf="(selectedAddress | async) === null">{{'address-not-selected' |
          transloco}}</span>
        <span *ngIf="selectedAddress | async">{{ currentLang == 'ru' ? (selectedAddress | async)?.nameRu :
          (selectedAddress | async)?.nameUa }}</span>
      </p>
      <span class="btn-change" (click)="toChangeDesktopLocation()">{{'change' | transloco}}</span>
    </div>

    <div class="switch-block">
      <div class="wrapper-address">
        <span class="mobile-select-region">{{ selectedUserCityName }},
          <span class="no-address" *ngIf="(selectedAddress | async) === null">{{'address-not-selected' |
            transloco}}</span>
          <span *ngIf="selectedAddress | async">{{ currentLang == 'ru' ? (selectedAddress | async)?.nameRu :
            (selectedAddress | async)?.nameUa }}</span>
        </span>

        <span (click)="toChangeRegion()" class="toChangeLocale">{{'change' | transloco}}</span>
      </div>
      <div class="btn-ddm filter-btn mobile-filters-ddm" (click)="openMobileFiltersModal()">
        <span class="icon-btn-ddm" [ngClass]="{
          'filter-switcher-enable': (countOfActiveMobileFilters | async | pharmaciesFiltersCount:currentFilterForBlock:filterList:isListSearch) > 0
        }" [ngStyle]="iconFtObj"></span>
        <span
          *ngIf="(countOfActiveMobileFilters | async | pharmaciesFiltersCount:currentFilterForBlock:filterList:isListSearch) == 0">{{'filter'
          | transloco}}</span>
        <span
          *ngIf="(countOfActiveMobileFilters | async | pharmaciesFiltersCount:currentFilterForBlock:filterList:isListSearch) > 0">{{'activeMobileFilters'
          | transloco}}
          ({{ countOfActiveMobileFilters | async | pharmaciesFiltersCount:currentFilterForBlock:filterList:isListSearch
          }})</span>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="counters"></ng-container>

    <div class="filters-wrapper">
      <ng-container *ngFor="let item of filterList | keyvalue : originalOrder">
        <div class="sort-icon" *ngIf="item.key === 'ds'"></div>
        <div class="filter-icon" *ngIf="item.key === 'fif'"></div>
        <ng-container>
          <div class="element filter-btn"
            [class.extra-margin-right-list-ua]="currentLang === 'ua' && isListSearch && item.key === 'qs'"
            [class.active-filter]="item.value.active"
            [class.hidden-filter]="!isListSearch && (item.key === 'qs' || item.key === 'fif')">
            <span class="filter-pc-btn" (click)="clickItemMenu(item)"
              [textContent]="item.value['name'] | transloco"></span>
            <span class="ddbtnmenu" *ngIf="item.value['children']" [ngStyle]="iconObj"></span>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <div (click)="switchBlockVisible()" class="toMap">
      <div class="open-map-icon">
        <span>{{'map.block.pharm' | transloco}}</span>
      </div>
      <img style="width: 100%" src="./assets/maps3.webp" alt="map" [title]="'map.block.pharm' | transloco">
    </div>

    <bz-spinner *ngIf="(isLoadingListPharmacies | async)"></bz-spinner>

    <div class="pharmacies-in-cart" *ngIf="(pharmaciesListInCart | async)?.size > 0">
      <span class="pharmacies-in-cart-title">
        <span>{{'current-reserve' | transloco}}:</span>
      </span>
      <bz-apteka *ngFor="let itcart of (pharmaciesListInCart | async) | keyvalue: originalOrder; trackBy: trackById"
        [ngStyle]="{'z-index': '1'}" [apteka]="itcart.value" [isPharmaciesPage]="true"
        (switchToMobileFromMap)="switchBlockVisible()"></bz-apteka>
    </div>

    <ng-container *ngFor="let item of (pharmaciesList | async) | keyvalue: originalOrder; trackBy: trackById; let i = index">
      <bz-apteka
        [class]="'index-' + i"
        [ngStyle]="{'z-index': '1'}"
        [apteka]="item.value"
        [isPharmaciesPage]="true"
        (switchToMobileFromMap)="switchBlockVisible()">
      </bz-apteka>
      <ng-container
        [ngTemplateOutlet]="banner"
        [ngTemplateOutletContext]="{
          index: i,
          banner: (banner$ | async),
          forShortList: false
        }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(pharmaciesList | async)?.size < 5">
      <ng-container
        [ngTemplateOutlet]="banner"
        [ngTemplateOutletContext]="{
          index: 0,
          banner: (banner$ | async),
          forShortList: true
        }">
      </ng-container>
    </ng-container>

    <div class="still" *ngIf="(totalPharmaciesLength | async) && !(isLoadingListPharmacies | async)"
      (click)="getNextPharmacies()" [textContent]="'show_more' | transloco"></div>

    <ng-container *ngIf="(pharmaciesOtherList | async)?.size > 0">
      <div class="pharmacies-in-other-cities">
        <span class="pharmacies-in-cart-title">
          <span>{{'inOtherCities' | transloco}}:</span>
        </span>
        <bz-apteka *ngFor="let item of (pharmaciesOtherList | async) | keyvalue: originalOrder; trackBy: trackById"
          [ngStyle]="{'z-index': '1'}" [apteka]="item.value" [isPharmaciesPage]="true"
          (switchToMobileFromMap)="switchBlockVisible()"></bz-apteka>
      </div>

    </ng-container>

    <div class="no-finded-pharmacies"
      *ngIf="(pharmaciesList | async)?.size === 0 && (pharmaciesOtherList | async)?.size === 0">
      {{'not-finded-pharmacies' | transloco }}.</div>

    <div class="still" *ngIf="(totalPharmaciesOtherLength | async)"
      [ngStyle]="{'margin-top': (pharmaciesList | async)?.size === 0 && (pharmaciesOtherList | async)?.size === 0 ? '15px' : ''}"
      (click)="getNextPharmacies(true)" [textContent]="'getOtherCityPharmacies' | transloco"></div>

    <div *ngIf="!(totalPharmaciesLength | async) && !(totalPharmaciesOtherLength | async)" class="still" [ngStyle]="{
        'pointer-events': 'none',
        'background-color' : '#f7f9fd',
        'border': 'none',
        'min-height': '0px',
        'margin-bottom': scr.isMobile() && _search_pharmcy_params_count > 1  ? '18px' : (scr.isDesktop() ? '' : '-40px')
      }"></div>

    <div class="faqs-wrapper">
      <ng-container *ngTemplateOutlet="seoFAQ"></ng-container>
    </div>

    <div class="table-wrapper">
      <ng-container *ngTemplateOutlet="seoTable"></ng-container>
      <ng-container *ngIf="seoPreparatText | async as text">
        <div class="seo-preparat-wrapper" [innerHTML]="text | safeHTML"></div>
      </ng-container>
    </div>

    <div class="static-footer" *ngIf="!(isLoadingListPharmacies | async)">
      <bz-static-footer [isPharmaciesPage]="true"></bz-static-footer>
    </div>
  </div>
</ng-template>

<ng-template #mapTemplate>
  <div (bzOutside)="clickOutsideMap($event)" #containerMap class="map-wrapper"
    [ngStyle]="{height: primaryHeightMapContent}">
    <div [ngClass]="{'closed-popup': closed}" *ngIf="selectedPharmacyForPopup" class="map-popup-seleted">

      <div class="close-map-popup-seleted">
        <div class="swither" (click)="closedRightPopup()">
          <span class="icon-btn-ddm" style="display: contents; color: white; font-size: 16px;"> &#8594;</span>
        </div>
      </div>

      <div [ngStyle]="{'height': (320 +
                 (selectedPharmacyForPopup?.products?.length > 1 ?
                  140 * selectedPharmacyForPopup.products.length : 0))
                    < (+(primaryHeightMapContent.replace('px', ''))) ? 'unset' :
                  +(primaryHeightMapContent.replace('px', '')) - 40 + 'px'
                 }" (bzOutside)="bzOutsideFromMobileVersion($event)" class="map-popup-seleted-inner scrollbar">
        <bz-apteka [ngStyle]="{'z-index': '1'}" [isPopUp]="true" [apteka]="selectedPharmacyForPopup"
          [isPopup]="selectedPharmacyForPopup.products.length > 0" [isPharmaciesPage]="true"
          [isListInfo]="selectedPharmacyForPopup?.isOpenInfo" (emmitContainer)="closedRightPopup()">
        </bz-apteka>
      </div>

    </div>
    <ng-template #map></ng-template>
    <ng-container *ngTemplateOutlet="counters; context: { modifier: 'hide-on-desktop' }"></ng-container>
  </div>
</ng-template>

<ng-template #seoCrumbs>
  <nav class="crumbs scrollbar" *ngIf="crumbs.length > 0">
    <span>
      <a [routerLink]="getHomeLink()">{{ 'search-for-drugs' | transloco }}</a>
    </span>
    <ng-container *ngFor="let crumb of crumbs">
      <span *ngIf="crumb?.info !== 'trade'" (click)="clearSearchState()">
        <a [textContent]="crumb?.name" [routerLink]="getCrumbRouterLink(crumb)"></a>
      </span>
    </ng-container>
  </nav>
</ng-template>

<ng-template #seoFAQ>
  <bz-faq [faqs]="(seoFaqsData | async)?.faqs" [heading]="(seoFaqsData | async)?.h2"
    [setDesktopWhiteBackground]="true"></bz-faq>
</ng-template>

<ng-template #seoTable>
  <bz-prices-table [isPharmacyPage]="true" [tableHeading]="(seoTableData | async)?.h2"
    [table]="(seoTableData | async)"></bz-prices-table>
</ng-template>

<ng-template #banner let-index="index" let-banner="banner" let-forShortList="forShortList">
  <div class="main-banner" [class.extra-margin]="forShortList" *ngIf="banner && ((index | bannerIndex) || forShortList)">
    <a [href]="banner.redirectTo">
      <picture class="banner-picture">
        <source [srcset]="bannerImages + banner.img + '.webp'" type="image/webp">
        <img bz-image [src]="bannerImages + 'png/' + banner.img + '.png'" [title]="'Банер'" [alt]="'Банер'">
      </picture>
    </a>
  </div>
</ng-template>

<ng-template #counters let-modifier="modifier">
  <div class="list-inputs-wrapper" [ngClass]="modifier" *ngIf="!isListSearch">
    <bz-count-packaging [qty]="((countForOneProduct | async)?.packageNum)" [type]="'parent'" [namePack]="'packaging'"
      (onDecrementCount)="removeParentQuantity($event)" (onIncrementCount)="addParentQuantity($event)">
    </bz-count-packaging>
    <bz-count-packaging *ngIf="(countForOneProduct | async)?.packageContentNum > 1"
      [qty]="(countForOneProduct | async)?.blisterNum" [type]="'child'"
      [max]="(countForOneProduct | async)?.packageContentNum - 1"
      [namePack]="(countForOneProduct | async)?.packageContentType" (onDecrementCount)="removeChildQuantity($event)"
      (onIncrementCount)="addChildQuantity($event)">
    </bz-count-packaging>
  </div>
</ng-template>